import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../../store/index';
import { selectLesionsToShow } from '../../../../../store';

export const useDiagnosticsEffects = (results) => {
  const dispatch = useDispatch();
  const lesionsToShow = useSelector(selectLesionsToShow);

  const [diagnosticsPopperOpen, setDiagnosticsPopperOpen] = useState(false);
  const [lockedClasses, setLockedClasses] = useState(new Set());

  useEffect(() => {
    setDiagnosticsPopperOpen(false);
  }, []);

  useEffect(() => {
    if (!lesionsToShow) return;

    const locked = new Set();
    for (const [key, value] of Object.entries(lesionsToShow)) {
      if (value) {
        locked.add(key);
      }
    }

    setLockedClasses(locked);
    dispatch(actions.updateDiagnosticsOverlaysToShow());
  }, [results, lesionsToShow, dispatch]);

  return {
    diagnosticsPopperOpen,
    setDiagnosticsPopperOpen,
    lockedClasses,
    setLockedClasses,
  };
};
